import { InputBase, IconButton } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  .inputTextStyleDate {
    text-align: left;
    letter-spacing: 0;
    color: #707891;
    padding: 5px 0;
  }
  .MuiIconButton-root {
    padding: 0px;
  }
  .Mui-focused {
    background-color: none;
  }
  .error-message {
    height: 20px;
  }
`;

interface StyledInputBaseProps {
  marginRight?: boolean;
  borderRadiusRight?: boolean;
  borderRadiusLeft?: boolean;
  textColor?: string;
  bgColor?: string;
  bold?: boolean;
  marginTop?: boolean;
}

export const StyledInputBase = styled(InputBase)<StyledInputBaseProps>`
  margin-right: ${({ marginRight }) => (marginRight ? '8px' : '0')};
  margin-top: ${({ marginTop }) => (marginTop ? '20px' : '0')};
  border-radius: ${({ borderRadiusLeft, borderRadiusRight }) =>
    borderRadiusLeft
      ? '4px 0 0 4px'
      : borderRadiusRight
      ? '0 4px 4px 0'
      : '4px'};
  border: 1px solid ${COLORS.FORM_INPUT_BORDER};
  height: 40px;
  width: ${({ fullWidth }) => (fullWidth ? '200px' : '100px')};
  padding: 12px;
  color: ${({ textColor }) => textColor || 'black'};
  background-color: ${({ bgColor }) => bgColor || 'white'};
  font-weight: ${({ bold }) => (bold ? 500 : 400)};
  font-size: 13px;

  .MuiInputBase-input:focus {
    background-color: transparent;
  }
`;

export const StyledKeyboardDatePicker = styled(KeyboardDatePicker)`
  border: 1px solid ${COLORS.FORM_INPUT_BORDER};
  border-radius: 4px;
  margin-right: 8px;
  font-size: 13px;
  height: 40px;
  width: 200px;
  padding: 0 12px;
  background-color: ${COLORS.FORM_INPUT_BG_GRAY};
`;

export const SearchButton = styled(IconButton)`
  width: 36px;
  height: 36px;
  background: #f9be00 0% 0% no-repeat padding-box;
  border: 1px solid #f9be00;
  border-radius: 4px;
  &:hover {
    background: #f9be00 0% 0% no-repeat padding-box;
    border: 1px solid #f9be00;
    border-radius: 4px;
  }
`;

export const RefreshButton = styled(IconButton)`
  width: 36px;
  height: 36px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #efefef;
  border-radius: 4px;
  margin-left: 8px;
`;
